<form
  [formGroup]="unlockForm"
  (ngSubmit)="handleUnlock()"
  class="flex flex-col h-full">
  <!-- Form Content -->
  <div class="flex-1 mt-6">
    <!-- Encryption Key Input -->
    <lib-input
      controlName="encryptionKey"
      label="Encryption Key"
      placeholder="Enter your encryption key"
      [disabled]="isSubmitting()" />

    <!-- Error Message -->
    @if (errorMessage()) {
    <p class="mt-1 text-xs text-typography-destructive-primary">
      {{ errorMessage() }}
    </p>
    }
  </div>

  <!-- Action Buttons -->
  @let isSubmittingValue = isSubmitting(); @let isFormInvalid =
  unlockForm.invalid; @let actionButtons = [{ id: 'close-btn', label: 'Close',
  variant: asActionButtonVariant('secondary'), disabled: isSubmittingValue }, {
  id: 'unlock-data-btn', label: isSubmittingValue ? 'Unlocking...' : 'Unlock
  Data', variant: asActionButtonVariant('primary'), disabled: isSubmittingValue
  || isFormInvalid, loading: isSubmittingValue }];

  <app-action-buttons
    [buttons]="actionButtons"
    (buttonClick)="onActionButtonClick($event)" />
</form>
